import type { ComparisonCard } from './ComparisonTable.types';

export const data: ComparisonCard[] = [
  {
    subtitle: 'WHAT YOU PAY NOW',
    price: '15,000+',
    period: 'per year',
    features: [
      { text: 'Aggregated third-party data', available: false },
      { text: 'Vendor lock-in contracts', available: false },
      { text: 'Surprise renewal terms', available: false },
      { text: 'Internal use only', available: false },
      { text: 'Legacy API technology', available: false },
    ],
    cta: { text: 'KEEP OVERPAYING' },
    theme: 'dark',
  },
  {
    title: 'Global Database',
    subtitle: 'SMART CHOICE',
    price: '588',
    period: 'per year',
    features: [
      { text: 'First-party government registry data', available: true },
      { text: 'Cancel anytime flexibility', available: true },
      { text: 'Price lock guarantee', available: true },
      { text: 'Full commercial rights', available: true },
      { text: 'Modern REST API', available: true },
    ],
    cta: { text: 'START SAVING NOW', anchor: 'pricing' },
    theme: 'light',
    highlight: true,
  },
];
